module.exports = __webpack_public_path__ + "static/img/logo_45.2457206.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_45.png
// module id = y6j+
// module chunks = 1